import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'pcln-design-system'
import styled from 'styled-components'
import Chip from '../Chip'

const ChipFilterWrapper = styled(Flex)`
  display: inline-block;
  position: relative;
`

const ChipFilter = ({ chipId, filter, handleChange, className }) => {
  const { checked, disabled, value } = filter
  const [isChecked, setChecked] = useState(false)

  useEffect(() => {
    if (!disabled) {
      setChecked(checked)
    }
  }, [checked, disabled])

  const updateSelection = () => {
    if (!disabled) {
      setChecked((isChecked) => !isChecked)
      handleChange &&
        handleChange({
          [value]: !isChecked,
        })
    }
  }

  return (
    <ChipFilterWrapper mt={2} className={className}>
      <Chip {...filter} checked={isChecked} updateSelection={updateSelection} chipId={chipId} />
    </ChipFilterWrapper>
  )
}

ChipFilter.propTypes = {
  checked: PropTypes.bool,
  chipId: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  filter: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
}

export default ChipFilter
